import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPageScreen from "./components/LandingPageScreen";
import ValuationFormScreen from "./components/ValuationFormScreen";
import ThankYouScreen from "./components/ThankYouScreen";
import ModelSelectionScreen from "./components/ModelSelectionScreen";
import RegionSelectionScreen from "./components/RegionSelectionScreen";
import DemandDriversScreen from "./components/DemandDriversScreen";
import AdminMarketSourcesScreen from "./components/AdminMarketSourcesScreen";

import TermsOfServiceScreen from "./components/TermsOfServiceScreen";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          {/* Use `element` instead of `component` */}
          <Route path="/" element={<LandingPageScreen />} />
          <Route path="/model-selection" element={<ModelSelectionScreen />} />
          <Route path="/region-selection" element={<RegionSelectionScreen />} />
          <Route path="/demand-drivers" element={<DemandDriversScreen />} />

          <Route path="/valuation" element={<ValuationFormScreen />} />
          <Route path="/thank-you" element={<ThankYouScreen />} />
          <Route path="/terms-of-service" element={<TermsOfServiceScreen />} />
          <Route path="/admin/market-sources" element={<AdminMarketSourcesScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
